import { render, staticRenderFns } from "./thumb.vue?vue&type=template&id=79f4237e"
import script from "./thumb.vue?vue&type=script&lang=js"
export * from "./thumb.vue?vue&type=script&lang=js"
import style0 from "./thumb.vue?vue&type=style&index=0&id=79f4237e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports